import * as _ from 'underscore';
import { Util } from '../models';
import { NotificationType } from '../enums';

export interface NotificationPropertyDescriptor extends PropertyDescriptor {
	value?: (...params: any[]) => Promise<any>;
}

interface StringFn {
	(): string;
}

export interface MAppNotificationOption {
	value: StringFn;
	condition: (...params: any[]) => boolean;
}

export function notify(
	successTitle?: StringFn | MAppNotificationOption,
	errorTitle?: string,
	successMessage?: string,
	errorMessage?: string
) {
	return function(target: any, propertyKey: string, descriptor: NotificationPropertyDescriptor) {
		let func = descriptor.value;
		descriptor.value = function(...params: any[]): Promise<any> {
			var _self = this;
			var _successTitle: string;
			var _showSuccess: boolean;
			if (isMAppNotificationOption(successTitle)) {
				if ((_showSuccess = successTitle.condition.apply(_self, params))) {
					_successTitle = successTitle.value();
				}
			} else {
				_showSuccess = true;
				_successTitle = successTitle();
			}
			return func.apply(_self, params).then(
				() => {
					if (_showSuccess) {
						Util.StudioNotification.show({
							title: _successTitle,
							text: successMessage,
							type: NotificationType.Success
						});
					}
				},
				(xhr: JQueryXHR) => {
					Util.StudioNotification.show({
						title: errorTitle
							? errorTitle
							: xhr && xhr.status
								? 'Error'.concat(' ', xhr.status.toString())
								: undefined,
						text: errorMessage ? errorMessage : xhr && xhr.statusText ? xhr.statusText : undefined,
						type: NotificationType.Error
					});
				}
			);
		};
		return descriptor;
	};
}
function isMAppNotificationOption(object: any): object is MAppNotificationOption {
	return object !== undefined && object !== null && !_.isFunction(object) && _.isObject(object);
}
